export default function flatEndpoints(data) {
    const flatArray = [];
  
    for (const id_ordine in data) {
      const endpoints = data[id_ordine];
      for (const endpoint of endpoints) {
        flatArray.push({
          ...endpoint,
          id_ordine, // aggiungo l'id_ordine come proprietà esplicita
        });
      }
    }
  
    return flatArray;
  }